module.exports = __webpack_public_path__ + "static/media/derecho-previsional (2).97c899e9.jpg";